import { render, staticRenderFns } from "./whats-new.vue?vue&type=template&id=7bf9c32a&"
import script from "./whats-new.vue?vue&type=script&lang=js&"
export * from "./whats-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports